import {Karen} from "../Karen";
import {TimelineLite, TweenLite} from "gsap";
import {KarenLayers, Layers} from "./KarenLayers";


export class SpineAnimation extends PIXI.Container {
    private _spineAnimation: PIXI.spine.Spine | null;

    constructor(jsonName: string) {
        super();
        this._spineAnimation = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset(jsonName));
        this._spineAnimation.autoUpdate = true;
        this._spineAnimation.visible = false;
    }

    public setStagePosition(stagePosition: PIXI.Point): void {
        this._spineAnimation!.position.set(stagePosition.x, stagePosition.y);

    }

    public stopWin(): void {

        if (this._spineAnimation) {
            const tl: TimelineLite = new TimelineLite();
            tl.add(new TweenLite(this._spineAnimation, 0.25, {
                alpha: 0, onComplete: () => {
                    this._spineAnimation!.state.setEmptyAnimation(0, 0);
                    this._spineAnimation!.visible = false;
                    this._spineAnimation!.alpha = 1;
                    if (this._spineAnimation!.parent) {
                        this._spineAnimation!.parent.removeChild(this._spineAnimation!);
                    }
                    this._spineAnimation!.destroy();
                    this._spineAnimation = null;
                }
            }));

        }
    }

    public playSpineAnimation(animName: string, abort: boolean = false, duration: number = 1): TimelineLite {
        const playTL: TimelineLite = new TimelineLite();
        if (this._spineAnimation) {
            duration = abort ? 0.2 : this.getAnimDuration(animName);
            playTL.add(() => {
                KarenLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!.addChild(this._spineAnimation!);
                this._spineAnimation!.visible = true;
                this._spineAnimation!.alpha = 1;
                this._spineAnimation!.state.setAnimation(0, animName, false);
                const trackEntry: PIXI.spine.core.TrackEntry = this._spineAnimation!.state.getCurrent(0);
                if (duration === 0) {
                    trackEntry.trackTime = trackEntry.animation.duration;
                } else {
                    abort && (trackEntry.trackTime = trackEntry.animation.duration);
                }
            }, 0);
            playTL.add(() => {
                this.stopWin();
            }, duration);
        }
        return playTL;
    }

    public getAnimDuration(animName: string): number {
        return this._spineAnimation!.spineData.findAnimation(animName).duration;
    }
}